import { Sparkles, Smartphone, Code2, MessagesSquare, Target, ClipboardList } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Stagger, StaggerItem } from "./Reveal";

const reasons = [
  { icon: Sparkles, title: "Modern Design", text: "Clean, contemporary design that presents your business professionally." },
  { icon: Smartphone, title: "Mobile Friendly", text: "Built to work well on phones, tablets and desktops." },
  { icon: Code2, title: "Custom Development", text: "Functionality built around your requirements, not forced into a template." },
  { icon: MessagesSquare, title: "Clear Communication", text: "Plain-English updates so you always know where your project is at." },
  { icon: Target, title: "Business Focused", text: "Every decision is made with your customers and your goals in mind." },
  { icon: ClipboardList, title: "We Launch It & Take Care of It", text: "Your quote is based on your requirements — and once built, we launch your new website and take care of it as well." },
];

export const WhyChooseUs = () => (
  <section id="why-us" className="section bg-ink2/50 border-y border-white/[0.05]" aria-labelledby="why-title">
    <div className="container-x grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <SectionHeading id="why-title" eyebrow="Why choose us" title="Straightforward, professional and focused on your business." subtitle="No exaggerated promises — just a modern website, built properly, with clear communication from start to finish." />
      <Stagger className="grid gap-x-8 gap-y-9 sm:grid-cols-2">
        {reasons.map(({ icon: Icon, title, text }) => (
          <StaggerItem key={title}>
            <div className="flex gap-4" data-testid={`why-item-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-white/10 bg-white/[0.03] text-violet-200"><Icon className="h-5 w-5" aria-hidden="true" /></span>
              <div>
                <h3 className="font-semibold text-white">{title}</h3>
                <p className="mt-1.5 text-sm text-slate-400 leading-relaxed">{text}</p>
              </div>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
